import { useState, useEffect } from "react";

import API_KEY from "./keys";
//  powerful hook that will return data from term
const CONTEXT_KEY = "f29875281db614909";

const UseGoogleSearch = (term) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      fetch(
        `https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${term}`
      )
      .then(response => response.json())
      .then(result => {
        setData(result)
      })
    }
    fetchData()
  }, [term])

  return { data }
};

export default UseGoogleSearch;
